import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext.jsx"
import api from "@api";
import "./CreateUserProfile.css";

function CreateUserProfile() {
 const navigate = useNavigate();
 const { refreshProfile } = useAuth();
 const [formData, setFormData] = useState({
  first_name: "",
  last_name: "",
  bio: "",
  city: "",
  state: "",
 });
  const [allSports, setAllSports] = useState([]);
  const [selectedSportIds, setSelectedSportIds] = useState([]);

 const [error, setError] = useState("");
 const [isSubmitting, setIsSubmitting] = useState(false);

 const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
   ...prev,
   [name]: value,
  }));
 };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");

  if (
   !formData.first_name.trim() ||
   !formData.last_name.trim() 
  ) {
   setError("First name and last name are required.");
   return;
  }

  try {
   setIsSubmitting(true);

    const profileData = {
      ...formData,
      display_name: `${formData.first_name.trim()} ${formData.last_name.trim()}`,
    };

    const res = await api.post(
      "/api/user-profiles-v2/me",
      profileData,
      {
        withCredentials: true,
      }
    );
    for (const sportId of selectedSportIds) {
      await api.post(
        "/api/user-profile-sports",
        {
          sport_id: sportId,
        },
        {
          withCredentials: true,
        }
      );
    }
    await refreshProfile();

    navigate(`/profile/${res.data.profile.id}`);
  } catch (err) {
   console.error("Create profile error:", err);

   setError(
    err.response?.data?.message ||
    "Failed to create your profile.",
   );
  } finally {
   setIsSubmitting(false);
  }
 };

  useEffect(() => {
    const fetchSports = async () => {
      try {
        const res = await api.get("/api/sports-catalog");

        setAllSports(res.data.sports || []);
      } catch (error) {
        console.error("Failed to fetch sports:", error);
      }
    };

    fetchSports();
  }, []);

  const handleToggleSport = (sportId) => {
    const id = Number(sportId);

    setSelectedSportIds((prev) => {
      if (prev.includes(id)) {
        return prev.filter(
          (selectedId) => selectedId !== id
        );
      }

      return [...prev, id];
    });
  };
 return (
  <div className="create-profile-page">
   <div className="create-profile-card">
    <div className="create-profile-header">
     <div className="create-profile-avatar">
           {formData.first_name || formData.last_name
             ? `${formData.first_name.charAt(0)}${formData.last_name.charAt(0)}`.toUpperCase()
             : "SH"}
     </div>

     <div>
      <p className="create-profile-eyebrow">
       SportingHip Profile
      </p>

      <h1>Create Your Profile</h1>

      <p className="create-profile-subtitle">
       Create your personal sports profile. You can add sports,
       teams, highlights, and activity later.
      </p>
     </div>
    </div>

    {error && (
     <div className="create-profile-alert error">
      {error}
     </div>
    )}

    <form
     className="create-profile-form"
     onSubmit={handleSubmit}
    >
     <div className="create-profile-grid">
      <div className="create-profile-field">
       <label htmlFor="first_name">First Name</label>

       <input
        type="text"
        id="first_name"
        name="first_name"
        value={formData.first_name}
        onChange={handleChange}
        placeholder="Enter first name"
       />
      </div>

      <div className="create-profile-field">
       <label htmlFor="last_name">Last Name</label>

       <input
        type="text"
        id="last_name"
        name="last_name"
        value={formData.last_name}
        onChange={handleChange}
        placeholder="Enter last name"
       />
      </div>


      <div className="create-profile-field">
       <label htmlFor="city">City</label>

       <input
        type="text"
        id="city"
        name="city"
        value={formData.city}
        onChange={handleChange}
        placeholder="Santa Ana"
       />
      </div>

      <div className="create-profile-field">
       <label htmlFor="state">State</label>

       <input
        type="text"
        id="state"
        name="state"
        value={formData.state}
        onChange={handleChange}
        placeholder="CA"
        maxLength={50}
       />
      </div>
           <div className="create-profile-field full-width">
             <label>My Sports</label>

             <small>
               Choose the sports you play or want to play.
             </small>

             <div className="create-profile-sports">
               {allSports.map((sport) => {
                 const isSelected =
                   selectedSportIds.includes(Number(sport.id));

                 return (
                   <button
                     key={sport.id}
                     type="button"
                     className={`create-profile-sport ${isSelected ? "selected" : ""
                       }`}
                     onClick={() =>
                       handleToggleSport(sport.id)
                     }
                   >
                     {isSelected && <span>✓</span>}
                     {sport.name}
                   </button>
                 );
               })}
             </div>
           </div>
      <div className="create-profile-field full-width">
       <label htmlFor="bio">Bio</label>

       <textarea
        id="bio"
        name="bio"
        value={formData.bio}
        onChange={handleChange}
        placeholder="Tell people a little about yourself and the sports you enjoy."
        rows={5}
        maxLength={500}
       />

       <small>
        {formData.bio.length}/500 characters
       </small>
      </div>
     </div>

     <div className="create-profile-actions">
      <button
       className="create-profile-button primary"
       type="submit"
       disabled={isSubmitting}
      >
       {isSubmitting ? "Creating Profile..." : "Create Profile"}
      </button>

      <button
       className="create-profile-button secondary"
       type="button"
       onClick={() => navigate(-1)}
       disabled={isSubmitting}
      >
       Cancel
      </button>
     </div>
    </form>
   </div>
  </div>
 );
}

export default CreateUserProfile;